<header class="main__content__header modal-header">
    <h2 class="modal-title">Detalhes da minha Solicitação</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>

<main class="main__content__modal modal-body" *ngIf="beneficio">
    <section class="content__modal__header">
        <section class="row">
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Beneficio Solicitado</span>
                <p class="content__modal__valor">{{beneficio.benefitType.description}}</p>
            </div>
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Data Solicitação</span>
                <p class="content__modal__valor">{{beneficio.solicitation.requestDate | date:'dd/MM/yyyy' || ' - '}}</p>
            </div>
        </section>

        <section class="row">
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Protocolo ANS</span>
                <p class="content__modal__valor">{{beneficio.solicitation.ansProtocol}}</p>
            </div>
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Status</span>
                <p class="content__modal__valor">
                    <status [status]="beneficio.status.description">
                    </status>
                </p>
            </div>
        </section>

        <section class="row" *ngIf="beneficio.motivoRecusa">
            <div class="col-sm-12 col-xl-12">
                <span class="content__modal__title">Motivo da Recusa</span>
                <p class="content__modal__valor">{{beneficio.motivoRecusa}}</p>
            </div>
        </section>

    </section>

    <section class="content__modal__table">
        <h4 class="header__title">
            Dependentes Declarados
        </h4>

        <ng-template #naoPossuiDependente>
            <p class="alerta-ng-template">Você não declarou dependentes!</p>
        </ng-template>

        <ul *ngIf="beneficio && beneficio.benefitDependant.length > 0 else naoPossuiDependente">
            <li *ngFor="let dependente of beneficio.benefitDependant"></li>
        </ul>

    </section>

    <section class="content__modal__table">
        <section class="modal__table__header">
            <h4 class="header__title">
                Documentos Anexados
            </h4>
            <span class="header__value" *ngIf="beneficio && beneficio.benefitDependant.length > 0">
                Total de
                <span>{{beneficio.solicitation.documents.length}} </span>
                resultados
            </span>
        </section>
        <section class="table-responsive modal__table__main">

            <ng-template #naoPossuiDocumentosAnexados>
                <p class="alerta-ng-template">Essa declaração não possui documentos anexados!</p>
            </ng-template>

            <div class="table-data-print" *ngFor="let file of beneficio.solicitation.documents">
                <span>{{file.filename}}</span>
                <span class="fa-icon icone-acao-form">
                    <fa-icon [icon]="faPrint" (click)="downloadFile(file.file, file.filename)"></fa-icon>
                </span>
            </div>

        </section>

        <section class="modal__table__footer">
            <!-- <ngb-pagination
                    [(page)]="paginaAtual"
                    [pageSize]="itensPorPagina"
                    [collectionSize]="listaEmprestimoDetalhado.length"
                ></ngb-pagination> -->
        </section>

    </section>
</main>